import { Grid, Stack } from '@mui/material';
import React from 'react';

import type { DevProject } from '../../../../utils/Types';
import { useParallax } from '../../../../utils/useParallax';

type Props = {
    project: DevProject;
};

export const DevProjectCard = ({ project }: Props) => {
    const { cardRef, handleMouseMove, handleMouseLeave, getParallaxStyle } = useParallax();

    return (
        <Grid
            className="dev-project-card"
            size={6}
            ref={cardRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={() =>
                project.url ? window.open(project.url, '_blank') : null
            }
            style={{
                cursor: project.url ? 'pointer' : 'default',
                ...getParallaxStyle(),
            }}
        >
            <Stack spacing={2}>
                <div className="dev-project-preview">
                    <img src={project.preview} />
                </div>
                <h2>{project.title}</h2>
                <div className="dev-project-skills">
                    <ul>
                        {project.skills.map((skill, i) => (
                            <li key={i}>{skill}</li>
                        ))}
                    </ul>
                </div>
                <p style={{ marginTop: 30 }}>{project.description}</p>
            </Stack>
        </Grid>
    );
};

export default DevProjectCard;
